import { useEffect, useState } from "react";
import Button from "../../../common/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  downloadDoctorReportList,
  getDoctorRecord,
  getDoctorReport,
  getRent,
  publishRecord,
  updateRecord,
} from "../../../../redux/Thunk/Doctor/DoctorThunks";
import toast from "react-hot-toast";
import Input from "../../../common/Input";
import { useFormik } from "formik";
import * as Yup from "yup";
import Loader from "../../../Loader";
import { debounce } from "lodash";
import Pagination from "../../../common/Pagination";
import Graph from "../../../common/Graph";
import ArrowRight from "../../../common/icons/ArrowRight";
import RecordsData from "../../../common/RecordsData";
import Checkedsquare from "../../../common/icons/Checkedsquare";

const PublishNew = ({ DocID, date }) => {
  const dispatch = useDispatch();
  const { doctorRecord, rentDetails, loading, doctorReport, doctorById } =
    useSelector((state) => state.doctor);
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [isPublish, setIsPublish] = useState(false);
  const [isSave, setIsSave] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [showIsEdit, setIsShowEdit] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [isReport, setIsReport] = useState(false);
  const [graphData, setGraphData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);
  const [initialData, setInitialData] = useState({
    id: "",
    DID: "",
    docName: "",
    category: "",
    docCat: "",
    gateways: "",
    account: "",
    trxType: "",
    date: "",
    period: "",
    fetchedRent: "",
    paidRent: "",
    trxId: "",
  });
  const [currentMonth, setCurrentMonth] = useState("");
  const [records, setRecords] = useState([]);

  useEffect(() => {
    if (DocID) setIsPublish(false);
    setRecords([]);
    setIsShowEdit(false);
    setIsSave(false);
    setIsEdit(false);
    setIsReport(false);
    setGraphData([]);
    setYear("");
    setMonth("");
  }, [DocID]);
  // Get the current month index
  useEffect(() => {
    const currentMonthIndex = new Date().getMonth(); // Get the current month (0-11)
    setCurrentMonth(currentMonthIndex);
  }, []);
  const startYear = new Date(date).getFullYear();

  // Get the current year
  const currentYear = new Date().getFullYear();
  const startMonth = new Date(date).getMonth();
  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i
  );
  const months = [
    { value: "January", label: "January" },
    { value: "February", label: "February" },
    { value: "March", label: "March" },
    { value: "April", label: "April" },
    { value: "May", label: "May" },
    { value: "June", label: "June" },
    { value: "July", label: "July" },
    { value: "August", label: "August" },
    { value: "September", label: "September" },
    { value: "October", label: "October" },
    { value: "November", label: "November" },
    { value: "December", label: "December" },
  ];

  const handleChangeYear = (event) => {
    setYear(event.target.value);
    setMonth("");
  };
  const handleChangeMonth = (event) => setMonth(event.target.value);

  useEffect(() => {
    if (doctorReport?.data?.length > 0) {
      setReportData(doctorReport?.data);
    }
  }, [doctorReport]);

  useEffect(() => {
    const debouncedFetchReport = debounce((id, year, month, page, limit) => {
      dispatch(getDoctorReport({ id, year, month, page, limit }));
    }, 300);
    const id = DocID;
    if (id) {
      const delay = setTimeout(() => {
        if (currentPage >= 1) {
          debouncedFetchReport(id, year, month, currentPage, limit);
        }
      }, 0);

      return () => {
        clearTimeout(delay);
        debouncedFetchReport.cancel();
      };
    }
  }, [currentPage, DocID, dispatch, limit, month, year]);

  useEffect(() => {
    const id = DocID;
    if (id) dispatch(getDoctorRecord(id));
  }, [DocID, dispatch]);

  useEffect(() => {
    if (doctorRecord?.length > 0) {
      const publishedRecords = doctorRecord?.filter(
        (record) => !record?.isPublish
      );

      setRecords(publishedRecords);
    }
  }, [doctorRecord]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialData,

    validationSchema: Yup.object({
      paidRent: Yup.number().required("Paid Fees is required").positive(),
      trxId: Yup.string().required("Transaction ID is required"),
      trxType: Yup.string().required("Transaction Type is required"),
    }),
    onSubmit: async (values) => {
      let updatedValues;

      updatedValues = {
        ...values,
        DID: values?.DID,
        isPublish: true,
        detail: graphData,
        FID: rentDetails?.data?.FID,
      };
      delete updatedValues?.docCat;
      delete updatedValues?.docName;
      try {
        const response = await dispatch(publishRecord(updatedValues)).unwrap();

        if (response?.status === 201 || response?.status === 200) {
          setIsPublish(false);
          toast?.success("Record publish successfully.");
        }
      } catch (error) {
        console.error("Failed to publish data:", error);
      }
    },
  });
  const getCurrentDate = () => {
    const today = new Date();
    return today?.toISOString();
  };
  const getTodaysDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${day}-${month}-${year}`;
  };
  useEffect(() => {
    if (Object.keys(rentDetails)?.length > 0) {
      const data = rentDetails?.data;
      const category = data?.doctor?.accountCategory?.category
        ? data?.doctor?.accountCategory?.category?.split("_")[1]
        : "";
      setInitialData({
        id: data?.id,
        docName: `${data?.DID} - ${data?.doctor?.personalInfo?.name} ${data?.doctor?.personalInfo?.surname}`,
        DID: data?.DID || "",
        docCat: category.toUpperCase(),
        category: data?.doctor?.accountCategory?.category || "",
        gateways: data?.gateways || "",
        account: data?.doctor?.paymentDetail?.bankAccountNumber || "",
        trxType: "",
        date: getCurrentDate(),
        period: `${data?.month} ${data?.year}` || "",
        fetchedRent: data?.fetchedRent || "",
        paidRent: "",
        trxId: "",
      });
    }
    if (rentDetails?.orderData?.length > 0) {
      setGraphData(rentDetails?.orderData);
    }
  }, [rentDetails]);

  const handleEditRecord = (record) => {
    const category = record?.category ? record?.category?.split("_")[1] : "";
    setInitialData({
      id: record?.id,
      DID: `${record?.DID}` || "",
      docName: `${doctorById?.DID} - ${doctorById?.personalInfo?.name} ${doctorById?.personalInfo?.surname}`,
      category: record?.category || "",
      docCat: category?.toUpperCase() || "",
      gateways: record?.gateways || "",
      account: record?.account || "",
      trxType: record?.trxType,
      date: getCurrentDate(),
      period: record?.period || "",
      fetchedRent: record?.fetchedRent || "",
      paidRent: record?.paidRent || "",
      trxId: record?.trxId || "",
    });
    if (record?.detail?.length > 0) {
      setGraphData(record?.detail);
    }
    setIsSave(true);
    setIsPublish(true);
    // handleOpenReport(record?.period);
  };

  const handleProceed = async () => {
    if (year && month) {
      const id = DocID;
      try {
        const response = await dispatch(getRent({ id, year, month })).unwrap();
        if (response?.status === 200 || response?.status === 201) {
          setIsPublish(true);
        } else {
          toast.error(response?.response?.data?.error);
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      toast.error("Please select both year and month.");
    }
  };
  const handleEdit = async (values) => {
    setIsSave(false);
    setIsShowEdit(true);
    setIsEdit(true);
  };
  const PublishRecord = async (values) => {
    if (!values?.trxId) {
      toast.error("Please enter transaction Id.");
    } else if (!values?.paidRent) {
      toast.error("Please enter paid rent.");
    } else if (!values?.trxType) {
      toast.error("Please enter transaction type.");
    }
    const payload = { ...values };

    payload.isPublish = true;
    payload.detail = graphData;
    const id = values?.id;
    delete payload.id;

    // Dispatch the action
    try {
      const response = await dispatch(updateRecord({ id, payload })).unwrap();
      if (response?.status === 201 || response?.status === 200) {
        setIsSave(false);
        setIsShowEdit(false);
        setIsEdit(false);
        setIsPublish(false);
        toast?.success("Record publish successfully.");
        const filterData =
          records?.length > 0
            ? records?.filter((record) => record?.id !== id)
            : [];
        setRecords(filterData);
      } else {
        if (response?.response?.data?.error) {
          toast.error(response?.response?.data?.error);
        }
      }
    } catch (error) {
      console.error("Failed to publish data:", error);
    }
  };
  const handleSave = async (values) => {
    if (!values?.trxId) {
      toast.error("Please enter transaction Id.");
    } else if (!values?.paidRent) {
      toast.error("Please enter paid rent.");
    } else if (!values?.trxType) {
      toast.error("Please enter transaction type.");
    } else {
      const updatedValues = {
        ...values,
        DID: values?.DID,
        isPublish: false,
        detail: graphData,
        FID: rentDetails?.data?.FID,
      };
      delete updatedValues?.docCat;
      delete updatedValues?.docName;
      try {
        const response = await dispatch(publishRecord(updatedValues)).unwrap();

        if (response?.status === 201 || response?.status === 200) {
          setIsSave(true);
          setIsReport(false);
          toast?.success("Record save successfully.");
        }
      } catch (error) {
        console.error("Failed to save data:", error);
      }
    }
  };
  const editRecord = async (values) => {
    let updatedValues;
    if (!values?.trxType) {
      toast.error("Please enter transaction type.");
    } else if (!values?.paidRent) {
      toast.error("Please enter paid rent.");
    } else if (!values?.trxId) {
      toast.error("Please enter transaction Id.");
    }

    updatedValues = {
      ...values,
      DID: values.DID,
      isPublish: false,
      detail: graphData,
      FID: rentDetails?.data?.FID,
    };
    delete updatedValues?.docCat;
    delete updatedValues?.docName;
    try {
      const response = await dispatch(publishRecord(updatedValues)).unwrap();

      if (response?.status === 201 || response?.status === 200) {
        setIsPublish(false);
        setIsSave(true);
        toast?.success("Record edited successfully.");
      }
    } catch (error) {
      console.error("Failed to edit data:", error);
    }
  };

  const handleOpenReport = async (period) => {
    if (isReport === false) {
      const id = DocID;
      let page = currentPage;
      const [month, year] = period.split(" ");
      const response = await dispatch(
        getDoctorReport({ id, year, month, page, limit })
      ).unwrap();

      if (response?.status === 200) {
        setMonth(month);
        setYear(year);
        setCurrentPage(1);
        setIsReport(true);
        setReportData(response?.data?.data);
      }
    } else {
      setIsReport(false);
    }
  };
  const totalPages = doctorReport?.totalPages || 1;

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const downloadCSV = async () => {
    const id = DocID;
    const month = doctorReport?.month;
    const year = doctorReport?.year;
    const response = await dispatch(
      downloadDoctorReportList({ id, year, month })
    ).unwrap();
    if (response.status === 200) {
      const csvContent = response?.data?.csvContent;
      //   const doctorReportData = response?.data?.data;
      //   const category = doctorReportData?.doctor?.accountCategory?.category;

      //   const accCategory = category ? category?.split("_")[1] : "";

      //   const doctorInfo = [
      //     [
      //       "Month",
      //       "Year",
      //       "Doctor Name",
      //       "Doctor ID",
      //       "Acc Category",
      //       "Clinic Name",
      //     ],
      //     [
      //       doctorReportData?.month || "",
      //       doctorReportData?.year || "",
      //       `${doctorReportData?.doctor?.personalInfo?.name || ""} ${
      //         doctorReportData?.doctor?.personalInfo?.surname || ""
      //       }`,
      //       doctorReportData?.doctor?.personalInfo?.DID || "",
      //       accCategory?.toUpperCase() || "",
      //       doctorReportData?.doctor?.personalInfo?.clinicName || "",
      //     ],
      //   ];

      //   const headers = [
      //     "Sr.No.",
      //     "C Date",
      //     "P Date",
      //     "Time",
      //     "Order ID",
      //     "Inv. No.",
      //     "Inv. Amount",
      //     "GST",
      //     "Margin",
      //     "Trx ID",
      //   ];

      //   const rows = doctorReportData.map((data, i) => {
      //     const completedDateObj = data?.deliveredTime
      //       ? new Date(data?.deliveredTime)
      //       : data?.collectedTime
      //       ? new Date(data?.collectedTime)
      //       : "";
      //     const completedDate = completedDateObj?.toLocaleDateString("en-GB", {
      //       day: "2-digit",
      //       month: "2-digit",
      //       year: "numeric",
      //     });
      //     const completedTime = completedDateObj?.toLocaleTimeString("en-GB", {
      //       hour: "2-digit",
      //       minute: "2-digit",
      //     });

      //     const placedDateObj = new Date(data?.createdAt);
      //     const placedDate = placedDateObj.toLocaleDateString("en-GB", {
      //       day: "2-digit",
      //       month: "2-digit",
      //       year: "numeric",
      //     });
      //     const placedTime = placedDateObj.toLocaleTimeString("en-GB", {
      //       hour: "2-digit",
      //       minute: "2-digit",
      //     });

      //     return [
      //       i + 1,
      //       data?.deliveredTime || data?.collectedTime ? completedDate : "N/A",
      //       placedDate || "N/A",
      //       data?.deliveredTime ? completedTime : "N/A",
      //       data?.OID || "",
      //       data?.invoice?.invoiceNo || "",
      //       data?.invoice?.invoiceAmount || "",
      //       data?.billing?.gst || "",
      //       data?.doctorOrderMargin?.marginPercentage || "",
      //       "N/A",
      //     ];
      //   });

      //   const csvContent = [
      //     ...doctorInfo.map((row) => row.join(",")),
      //     "",
      //     headers.join(","),
      //     ...rows.map((row) => row.join(",")),
      //   ].join("\n");

      //   // Trigger download
      // const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      // const url = URL.createObjectURL(blob);
      // const link = document.createElement("a");
      // link.href = url;
      // link.download = "doctor_report.csv";
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
      if (csvContent) {
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "doctor_report.csv";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
      } else {
        console.error("CSV content is empty or undefined.");
      }
    } else {
      toast.error(response?.response?.data?.message);
    }
  };

  const handleCancelRecord = () => {
    setIsPublish(false);
    const id = DocID;
    dispatch(getDoctorRecord(id));
  };
  const { touched, errors } = formik;
  const category =
    doctorReport?.data?.length > 0
      ? doctorReport?.data[0]?.doctor?.accountCategory?.category
      : "";
  const accCategory = category ? category?.split("_")[1] : "";

  return (
    <div className="tab-2">
      <Loader loading={loading} />
      {!isPublish && (
        <div className="flex items-center gap-4">
          <div>
            <select
              id="year"
              name="year"
              className="border-none shadow-none outline-none bg-primary-50 p-4 min-h-[57px] placeholder:text-secondry-600 w-full rounded-[8px] bg-[right_8px_center]"
              onChange={handleChangeYear}
              defaultValue=""
              value={year}
            >
              <option value="" disabled>
                Select year
              </option>
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>

          <div>
            <select
              id="month"
              name="month"
              className="border-none shadow-none outline-none bg-primary-50 p-4 min-h-[57px] placeholder:text-secondry-600 w-full rounded-[8px] bg-[right_8px_center]"
              onChange={handleChangeMonth}
              defaultValue=""
              value={month}
            >
              <option value="" disabled>
                Select month
              </option>
              {months.map((month, index) => (
                <option
                  key={month.value}
                  value={month.value}
                  // disabled={year == currentYear && index > currentMonth}
                  disabled={
                    Number(year) === Number(currentYear)
                      ? index > currentMonth
                      : index < startMonth
                  }
                >
                  {month?.label}
                </option>
              ))}
            </select>
          </div>
          <Button
            className="bg-primary-600 border border-primary-600 h-[36px] text-white py-2 px-3 min-w-[220px] text-[13px] leading-[20px] rounded-[8px] flex items-center justify-between gap-2 shadow-none outline-none"
            onClick={handleProceed}
          >
            Proceed
            <ArrowRight />
          </Button>
        </div>
      )}

      {isPublish && (
        <div>
          <form onSubmit={formik?.handleSubmit}>
            <div className="flex items-center flex-wrap mb-4">
              <div className="w-full xl:w-[calc(100%_-_180px)] xl:pr-[25px] max-xl:mb-3">
                <div className="grid grid-cols-12 gap-[8px]">
                  <div className="col-span-12 md:col-span-6 lg:col-span-4">
                    <Input
                      inputBox="mb-0"
                      type="text"
                      labelName="Doctor ID, Name"
                      labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                      className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                      name="DID"
                      value={formik?.values?.docName}
                      onChange={formik.handleChange}
                      disabled
                      disabledClass="bg-primary-50 border-primary-50 "
                      padding="none"
                    />
                  </div>
                  <div className="col-span-12 md:col-span-6 lg:col-span-4">
                    <Input
                      inputBox="mb-0"
                      type="text"
                      labelName="Category"
                      labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                      className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                      name="category"
                      value={formik?.values?.docCat}
                      onChange={formik.handleChange}
                      disabled
                      disabledClass="bg-primary-50 border-primary-50 "
                      padding="none"
                    />
                  </div>
                  <div className="col-span-12 md:col-span-6 lg:col-span-4">
                    <Input
                      inputBox="mb-0"
                      type="text"
                      labelName="Gateways"
                      labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                      className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                      name="gateways"
                      value={formik?.values?.gateways}
                      onChange={formik.handleChange}
                      disabled
                      disabledClass="bg-primary-50 border-primary-50 "
                      padding="none"
                    />
                  </div>
                  <div className="col-span-12 md:col-span-6 lg:col-span-4">
                    <Input
                      inputBox="mb-0"
                      type="text"
                      labelName="Account"
                      labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                      className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                      name="account"
                      value={formik?.values?.account}
                      onChange={formik.handleChange}
                      disabled
                      disabledClass="bg-primary-50 border-primary-50 "
                      padding="none"
                    />
                  </div>
                  <div className="col-span-12 md:col-span-6 lg:col-span-4">
                    <Input
                      placeholder="Enter"
                      inputBox="mb-0"
                      type="text"
                      labelName="Trx Type"
                      labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                      className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                      name="trxType"
                      value={formik?.values?.trxType}
                      onChange={formik.handleChange}
                      isError={touched?.trxType && Boolean(errors?.trxType)}
                      errorMessage={errors?.trxType}
                      disabled={isSave}
                      disabledClass="bg-primary-50 border-primary-50 "
                      padding="none"
                    />
                  </div>
                  <div className="col-span-12 md:col-span-6 lg:col-span-4">
                    <Input
                      inputBox="mb-0"
                      type="text"
                      labelName="Date"
                      labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                      className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                      name="date"
                      value={getTodaysDate()}
                      onChange={formik.handleChange}
                      disabled
                      disabledClass="bg-primary-50 border-primary-50 "
                      padding="none"
                    />
                  </div>
                  <div className="col-span-12 md:col-span-6 lg:col-span-3">
                    <Input
                      inputBox="mb-0"
                      type="text"
                      labelName="Period"
                      labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                      className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                      name="period"
                      value={formik?.values?.period}
                      onChange={formik.handleChange}
                      disabled
                      disabledClass="bg-primary-50 border-primary-50 "
                      padding="none"
                    />
                  </div>
                  <div className="col-span-12 md:col-span-6 lg:col-span-3">
                    <Input
                      inputBox="mb-0"
                      type="text"
                      labelName="Fetched Fees"
                      labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                      className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                      name="fetchedRent"
                      value={formik?.values?.fetchedRent}
                      onChange={formik.handleChange}
                      disabled
                      disabledClass="bg-primary-50 border-primary-50 "
                      padding="none"
                    />
                  </div>
                  <div className="col-span-12 md:col-span-6 lg:col-span-3">
                    <Input
                      placeholder="Enter"
                      inputBox="mb-0"
                      type="text"
                      labelName="Paid Fees"
                      labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                      className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                      name="paidRent"
                      value={formik?.values?.paidRent}
                      onChange={formik.handleChange}
                      isError={touched?.paidRent && Boolean(errors?.paidRent)}
                      errorMessage={errors?.paidRent}
                      disabled={isSave}
                      disabledClass="bg-primary-50 border-primary-50 "
                      padding="none"
                    />
                  </div>
                  <div className="col-span-12 md:col-span-6 lg:col-span-3">
                    <Input
                      placeholder="Enter"
                      inputBox="mb-0"
                      type="string"
                      labelName="Trx ID"
                      labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                      className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                      name="trxId"
                      value={formik?.values?.trxId}
                      onChange={formik.handleChange}
                      isError={touched?.trxId && Boolean(errors?.trxId)}
                      errorMessage={errors?.trxId}
                      disabled={isSave}
                      disabledClass="bg-primary-50 border-primary-50 "
                      padding="none"
                    />
                  </div>
                </div>
              </div>
              <div className="flex-wrap w-full xl:w-[180px] xl:flex-col flex gap-3">
                {isSave && (
                  <Button
                    className="border-primary-600 border h-[36px] text-secondry-60 py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                    onClick={handleCancelRecord}
                    type="button"
                  >
                    Cancel
                  </Button>
                )}

                {isSave ? (
                  <Button
                    className="bg-green-100 text-green-600 border border-green-600 h-[36px] py-2 px-5 min-w-[136px] text-[13px] font-medium leading-[20px] rounded-full flex justify-center items-center gap-2 shadow-sm outline-none"
                    type="button"
                  >
                    <Checkedsquare />
                    Saved
                  </Button>
                ) : showIsEdit ? (
                  <>
                    <Button
                      className="border-primary-600 border h-[36px] text-secondry-600 py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                      type="button"
                      onClick={() => handleOpenReport(formik.values?.period)}
                    >
                      {isReport ? "Close Report" : "Open Report"}
                    </Button>
                    <Button
                      className="border-primary-600 border h-[36px] text-secondry-600 py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                      onClick={() => editRecord(formik.values)}
                      // onClick={() => setIsPublish(false)}
                      type="button"
                    >
                      Edit
                    </Button>
                  </>
                ) : !showIsEdit && !isSave ? (
                  <Button
                    className="border-primary-600 border h-[36px] text-secondry-600 py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                    onClick={() => setIsPublish(false)}
                    type="button"
                  >
                    Cancel
                  </Button>
                ) : (
                  ""
                )}

                {isSave ? (
                  <Button
                    className="border-primary-600 border h-[36px] text-secondry-600 py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                    onClick={() => handleEdit(formik.values)}
                    type="button"
                  >
                    Edit
                  </Button>
                ) : isEdit ? (
                  <Button
                    className="border-primary-600 border h-[36px] text-secondry-600 py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                    type="button"
                    onClick={() => PublishRecord(formik.values)}
                  >
                    Publish
                  </Button>
                ) : (
                  <Button
                    className="border-primary-600 border h-[36px] text-secondry-600 py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                    type="button"
                    onClick={() => handleOpenReport(formik.values?.period)}
                  >
                    {isReport ? "Close Report" : "Open Report"}
                  </Button>
                )}
                {isSave ? (
                  <Button
                    className="bg-primary-600 h-[36px] text-white py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                    onClick={() => PublishRecord(formik.values)}
                    type="button"
                  >
                    Publish
                  </Button>
                ) : (
                  <Button
                    className="bg-primary-600 h-[36px] text-white py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                    onClick={() => handleSave(formik.values)}
                    type="button"
                  >
                    Save
                  </Button>
                )}
              </div>
            </div>
          </form>
          <div className="bg-primary-50 p-5 rounded-xl">
            {isReport ? (
              <section className="bg-gray-100 border border-primary-100 rounded-[8px] overflow-hidden">
                <div className="admin-table">
                  <table>
                    <thead>
                      <tr>
                        <th>Month</th>
                        <th>Year</th>
                        <th>Doctor Name</th>
                        <th>Doctor ID</th>
                        <th>Acc Category</th>
                        <th>Clinic Name</th>
                      </tr>
                      <tr>
                        <th>{doctorReport?.month || ""}</th>
                        <th>{doctorReport?.year || ""}</th>
                        <th>{`${
                          doctorReport?.data?.length > 0
                            ? doctorReport?.data[0]?.doctor?.personalInfo?.name
                            : ""
                        } ${
                          doctorReport?.data?.length > 0
                            ? doctorReport?.data[0]?.doctor?.personalInfo
                                ?.surname
                            : ""
                        }`}</th>
                        <th>{` ${
                          doctorReport?.data?.length > 0
                            ? doctorReport?.data[0]?.doctor?.personalInfo?.DID
                            : ""
                        }`}</th>
                        <th>{accCategory?.toUpperCase() || ""}</th>
                        <th>
                          {doctorReport?.data?.length > 0
                            ? doctorReport?.data[0]?.doctor?.personalInfo
                                ?.clinicName
                            : ""}
                        </th>
                      </tr>
                    </thead>
                  </table>
                  <table>
                    <thead>
                      <tr>
                        <th className="w-[100px]">Sr.No.</th>
                        <th className="w-[100px]">C Date</th>
                        {/* <th className="w-[100px]">Completed Time</th> */}
                        <th className="w-[100px]">P Date</th>
                        <th className="w-[100px]">Time</th>
                        <th>Order ID</th>
                        <th>Inv. No.</th>
                        <th>Inv. Amount</th>
                        <th className="w-[120px]">GST</th>
                        <th className="w-[150px]">Margin</th>
                        <th className="w-[200px]">Trx ID</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportData?.length > 0
                        ? reportData?.map((data, i) => {
                            const completedDateObj =
                              data?.deliveredTime !== null
                                ? new Date(data?.deliveredTime)
                                : data?.collectedTime !== null
                                ? new Date(data?.collectedTime)
                                : "";

                            const completedDate =
                              completedDateObj?.toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              });
                            const completedTime =
                              completedDateObj?.toLocaleTimeString("en-GB", {
                                hour: "2-digit",
                                minute: "2-digit",
                              });

                            // Format the Placed Date and Time
                            const placedDateObj = new Date(data?.createdAt);
                            const placedDate = placedDateObj.toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              }
                            );

                            return (
                              <tr>
                                <td>{i + 1}</td>
                                <td>
                                  {data?.deliveredTime !== null ||
                                  data?.collectedTime !== null
                                    ? completedDate
                                    : null}
                                </td>
                                {/* <td>
                                  {data?.deliveredTime ? completedTime : null}
                                </td> */}
                                <td>{placedDate}</td>
                                <td>
                                  {" "}
                                  {data?.deliveredTime || data?.collectedTime
                                    ? completedTime
                                    : null}
                                </td>
                                <td>{data?.OID || null}</td>
                                <td>{data?.invoice?.invoiceNo || null}</td>
                                <td>{data?.invoice?.invoiceAmount || null}</td>
                                <td>{data?.billing?.gst || null}</td>
                                <td>
                                  {data?.doctorOrderMargin?.marginPercentage !==
                                    undefined &&
                                  data?.doctorOrderMargin?.marginPercentage !==
                                    null
                                    ? data.doctorOrderMargin.marginPercentage.toFixed(
                                        2
                                      )
                                    : null}
                                </td>
                                <td>N/A</td>
                              </tr>
                            );
                          })
                        : "No record found"}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colSpan={6}>
                          {/* Pagination Component */}
                          <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPreviousPage={handlePreviousPage}
                            onNextPage={handleNextPage}
                            isPreviousDisabled={currentPage === 1}
                            isNextDisabled={currentPage === totalPages}
                            totalItems={doctorReport?.totalItems}
                            itemLength={doctorReport?.data?.length}
                          />
                        </th>
                        <th>Margin Sum</th>
                        <th>₹ {doctorReport?.totalMarginPercentage || 0.0}</th>
                        <th>
                          <button
                            className="underline"
                            onClick={() => downloadCSV()}
                          >
                            DOWNLOAD REPORT
                          </button>
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </section>
            ) : (
              <Graph graphData={graphData} />
            )}
          </div>
        </div>
      )}

      {doctorRecord?.length > 0 && !isPublish
        ? records?.map((record, i) => {
            const formattedDate = new Date(record?.date).toLocaleDateString(
              "en-GB"
            );
            return (
              <div className="bg-gray-100 mt-3 p-5 mb-8 rounded-xl flex items-end flex-wrap">
                <div className="w-full xl:w-full xl:pr-[25px] max-xl:mb-3">
                  <RecordsData
                    record={record}
                    formattedDate={formattedDate}
                    save={true}
                  />
                </div>
                <div className="w-full pt-3 text-center">
                  <div className="">
                    {/* <Graph graphData={record?.detail} /> */}
                    <Button
                      className="border-primary-600 border h-[36px] text-secondry-600 py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                      onClick={() => handleEditRecord(record)}
                      type="button"
                    >
                      Edit
                    </Button>
                  </div>
                </div>
              </div>
            );
          })
        : null}
    </div>
  );
};

export default PublishNew;
